import React from 'react';
import CourseHighlights from '../../Shared/Courses/CourseHighlights';
import CourseOperate from '../../Shared/Courses/CourseOperate';
import CodingBoy from '../../../img/Course-Elements/WebDev2.png';

const WebDevelopment = () => {
    return (
        <div className='px-4 md:px-12 pt-10'>
            <h4 className='text-blue-500 text-xl'>Certified Online Course</h4>
            <h1 className='text-blue-500 text-4xl font-semibold my-4'>Web <span className='text-orange-400'>Development</span></h1>
            <h1 className='text-4xl font-semibold my-4'>Course @ Rs. 1199</h1>
            <h2 className=''>Learn Web Development: HTML/CSS, JavaScript, React and build a website from scratch!</h2>
            <h3 className='text-xl my-4 font-semibold'>8 Weeks, 45 min /day (3 Recorded+2 Live)</h3>
            <h5>Offer: Get flat Rs.200 off oby applying the promo code CAREERHikers</h5>
            <h1 className='text-5xl mt-4 font-bold'>Download the</h1>
            <h1 className='text-5xl mt-2 text-orange-500 font-bold'><span className='text-blue-500'>APP</span> Now!</h1>
            <CourseHighlights />
            <div className='flex mb-8 mt-12'>
                <div className='flex-1 md:mr-4'>
                    <h1 className='text-3xl font-semibold mb-6'>Why Learn Web Development?</h1>
                    <h2 className='text-xl my-2'>Build awesome websites</h2>
                    <p>Facebook was founded by Mark Zuckerberg. Flipkart was founded by Sachin Bansal. What will you create?</p>
                    <h1 className='text-2xl my-2'>Be in demand</h1>
                    <h3>With 1.7 billion websites on the internet, it is one of the trendiest job possibilities, with Glassdoor reporting an average fresher income of 6 LPA for full stack devs.</h3>
                    <h1 className='text-xl my-2'>Eat-Sleep-Code-Repeat</h1>
                    <p className='text-sm'>Coding is constantly on your mind, rain or shine.</p>
                </div>
                <img className='flex-1' src={CodingBoy} alt="" />
            </div>
            <CourseOperate />
        </div>
    );
};

export default WebDevelopment;